module.exports = function (Component) {
  Component.options.__i18n = Component.options.__i18n || []
  Component.options.__i18n.push('{"en":{"message":"Currently displaying all interactions since","loadMoreBtn":"Load More"},"es":{"message":"Actualmente mostrando todas las interacciones desde","loadMoreBtn":"Cargar más resultados"}}')
  delete Component.options._Ctor
}
